<template>
  <div class="imprint">
    <router-link :to="{ path: '/' }" class="back-button">Back</router-link>
    <div class="content" v-html="data.imprint"></div>
  </div>
</template>

<script>
export default {
  name: 'imprint',
  props: ['data']
}
</script>
<style lang="scss">
  .imprint {
    h1, h2, h3, h4, h5, h6 {
      font-size: 1.3em;
      margin-bottom: .25em;
      margin-top: 1.5em;
    }
    h1 + p, h2 + p, h3 + p, h4 + p, h5 + p, h6 + p {
      margin-top: 0;
    }
    padding: 20vw 1em 0 1em;
    font-size: 2.8vw;
    font-weight: 400;
    @media screen and (orientation: portrait) {
      font-size: 5vw;
    }
    a.back-button {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      border: none !important;
      font-size: 22vw;
      letter-spacing: -0.015em;
      text-align: center;
      &:hover img {
        opacity: .7
      }
    }
  }
</style>
